export default __webpack_public_path__ + "static/media/f-03.16d0f679.jpg";